import React, { useState } from "react";
import { MdWaterDrop } from "react-icons/md";
import { HiOutlineViewGridAdd } from "react-icons/hi";
import { GiScubaTanks } from "react-icons/gi";
import { FaSyringe } from "react-icons/fa";
import style from "./Completed.module.scss";
import styled from "./Modal.module.scss";
import { ConfirmationModal } from "../../Modal/ConfirmationModal";
import { SuccessModal } from "../../Modal/SuccessModal";
import MessageInstruction from "../../modalInstruction/MessageInstruction";
import { constructOrderDate } from "../../../helper/DateFormatter";
import { useDispatch } from "react-redux";
import { completedOrders } from "../../../redux/orders/actions/orders.actions";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { InfoCircleFilled, IssuesCloseOutlined } from "@ant-design/icons";
import UpdateForm from "../../modalInstruction/UpdateForm";

const Completed = ({
  order_id,
  id,
  b_type,
  genotype,
  blood,
  order_state,
  request_type,
  order_amt,
  contact,
  hospital,
  product,
  address,
  Name,
  state,
  tym,
  complete_tym,
  accepted_time,
  delivered_time,
  dispatch,
  order_by,
  qty,
  title,
  reason,
  closed,
  dispatch_name,
  vendor_name,
  payment_type,
  rating,
}) => {
  const [cancelModal, setCancelModal] = useState(false);
  const [closeModal, setCloseModal] = useState(false);

  const badgeColor = () => {
    if (blood === "Blood") return "#FDE0E0";
    if (blood === "oxygen") return "#E0EFFD";
    return "#F0FDE0";
  };

  const icons = () => {
    if (blood === "Blood") return <MdWaterDrop size={25} color="#B70303" />;
    if (blood === "oxygen") return <GiScubaTanks size={25} color="#2457C5" />;
    return <FaSyringe size={25} color="#78A55A" />;
  };

  const colors = () => {
    if (blood === "Blood") return "#B70303";
    if (blood === "oxygen") return "#2457C5";
    return "#78A55A";
  };

  const dispatcher = useDispatch();

  const handleUpdate = () => {
    setCancelModal(false);
    setCloseModal(true);
  };

  const exitModal = () => {
    setCloseModal(false);
    dispatcher(completedOrders());
  };

  return (
    <>
      <div>
        <div className={style.container}>
          <div className={style.innerContainer}>
            <div className={style.content}>
              <div
                className={`${style.icon}`}
                style={{ background: badgeColor() }}
              >
                {icons()}
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>Product Name</p>
                <p className={style.text}>{b_type}</p>
              </div>
            </div>

            <div className={style.content}>
              <div className={style.icon} style={{ background: badgeColor() }}>
                <HiOutlineViewGridAdd size={25} color={colors()} />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>QUANTITY</p>
                <p className={style.text}>{order_amt}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>HOSPITAL NAME</p>
                <p className={style.text} style={{ width: "15vw" }}>
                  {Name}
                </p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>PAYMENT TYPE</p>
                <p className={style.text} style={{ width: "15vw" }}>
                  {payment_type}
                </p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>DISPATCH</p>
                <p className={style.text} style={{ width: "15vw" }}>
                  {dispatch}
                </p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>Order Time</p>
                <p className={style.text} style={{ width: "12vw" }}>
                  {constructOrderDate(tym)}
                </p>
              </div>
            </div>
            <div className={style.content}>
              {accepted_time ? (
                 <div className="d-flex flex-column">
                 <p className={style.header}>Accepted Time</p>
                 <p className={style.text} style={{ width: "12vw" }}>
                   {constructOrderDate(accepted_time)}
                 </p>
               </div>
              ) : (
                <div className="d-flex flex-column">
                <p className={style.header}>Accepted Time</p>
                <p className={style.text} style={{ width: "12vw" }}>
                  Unavailable
                </p>
              </div>
              )}
            </div>
            <div className={style.content}>
              {delivered_time ? (
                 <div className="d-flex flex-column">
                 <p className={style.header}>Delivery Time</p>
                 <p className={style.text} style={{ width: "12vw" }}>
                   {constructOrderDate(delivered_time)}
                 </p>
               </div>
              ): (
                <div className="d-flex flex-column">
                <p className={style.header}>Delivery Time</p>
                <p className={style.text} style={{ width: "12vw" }}>
                  Unavailable
                </p>
              </div>
              )}
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>TIME COMPLETED</p>
                <p className={style.text} style={{ width: "12vw" }}>
                  {constructOrderDate(complete_tym)}
                </p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>RATINGS</p>
                <p className={style.text} style={{ width: "12vw" }}>
                  {rating ? rating : "N/A"}
                </p>
              </div>
            </div>
            <div className={`${style.content} ${style.address}`}>
              <div className={style.icon} style={{ background: badgeColor() }}>
                <InfoCircleFilled
                  style={{ color: colors(), fontSize: "25px" }}
                />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>STATUS</p>
                <p className={style.text}>{closed}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Close MODAL */}
        <SuccessModal
          open={closeModal}
          onClose={() => setCloseModal(false)}
          bgcolor={colors()}
          width="50vw"
          height="35vh"
          instruction={
            <MessageInstruction
              heading={"ORDER CANCELLED SUCCESSFULLY!!"}
              // content={` It took this order ${closed?.time} Hours to be closed`}
              button="OKAY"
              onClickBtn={exitModal}
              color={badgeColor()}
            />
          }
        />

        {/* close details MODAL */}
        <ConfirmationModal
          open={cancelModal}
          handleClose={() => setCancelModal(false)}
          closemodal={() => setCancelModal(false)}
          bgcolor=" rgba(255, 255, 255, 0.92)"
          width="45vw"
          instruction={
            <div className="d-flex flex-column justify-content-center">
              <div className="d-flex justify-content-between mt-3 mb-3">
                <p className={styled.breadcumb} style={{ color: colors() }}>
                  <IssuesCloseOutlined
                    style={{ fontSize: "35px" }}
                    className="me-3"
                  />
                  <span>CANCEL ORDER</span>{" "}
                </p>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <UpdateForm
                  title={title}
                  order_id={order_id}
                  onClickNo={() => setCancelModal(false)}
                  onClickYes={() => handleUpdate()}
                />
              </div>
            </div>
          }
        />
      </div>
    </>
  );
};

export default Completed;
